import { Dispatch } from 'redux';
import { uploadDocument } from '../../../../global/ducks/document-upload-api';
import { createJsonFile, renameFile } from '../../../../global/helpers/file-helpers';
import { DocumentUploadState } from './document-upload-models';

const cpd = 'cpd';

export const processRequestWithDocumentUpload = (docUploadState: DocumentUploadState, personGuid: string, dispatch: Dispatch, onDocUploadSucess: (data: any) => void, onFailure?: () => void, source?: string, nodeType?: string) => {
	const formData = new FormData;
	const metaData = { node_type: nodeType || cpd };
	const jsonFile = createJsonFile('fileMetadata.json', metaData);
	formData.append('documentMetadata', jsonFile);
	const renamedFiles = docUploadState.stagedDocuments?.map(a => renameFile(a));
	renamedFiles?.forEach(file => formData.append('filedata', file));
	dispatch(uploadDocument(
		personGuid,
		formData,
		onDocUploadSucess,
		onFailure,
		source,
	));
};

